<ul class="menu-icons-wrap">
  @for (menuElement of menuStructure; track menuElement.title) { @if ((!menuElement.requiredRole ||
  (authFacade.hasRole$(menuElement.requiredRole) | async)) && (!menuElement.featureFlagKey ||
  (isFeatureFlagEnabled(menuElement.featureFlagKey) | async))) {
  <li *show="menuElement.permission" class="menu-item tw-flex" (click)="onMenuIconClick(menuElement)">
    <button
      type="button"
      class="tw-self-center"
      mat-icon-button
      [matTooltip]="menuElement.title | translate"
      [matTooltipPosition]="'right'"
    >
      @if (menuElement.icon) {
      <ui-svg-icon [name]="menuElement.icon" class="tw-mr-0"></ui-svg-icon>
      }
    </button>
  </li>
  } }
</ul>
